<template>
  <HomeLayout>
    <b-row class="column-border-container">
      <b-col class="column-border col-lg-6 card-col col-md-12 col-sm-12 col-12">
        <a
          class="vtd-card vtd-animate-shake" style="cursor:pointer"
          @click.prevent="clickBioPicture"
        >
          <div class="vtd-home-block">
            <h6 class="vtd-card-title d-none d-lg-block">01</h6>
            <h5>ALL<br/>BIO PICTURE</h5>
            <div class="vtd-text-center">
              <i class="material-icons vtd-icon-7"></i>
            </div>
            <p class="d-none d-lg-block" style="text-align: left">Update your bio and picture with a recent snap.</p>
          </div>
          <div class="vtd-card-footer vtd-text-center d-none d-lg-block">
            <p class="vtd-home-btn pl-2">Update Now</p>
          </div>
        </a>
      </b-col>

      <b-col class="column-border col-lg-6 card-col col-md-12 col-sm-12 col-12">
        <a
          class="vtd-card vtd-animate-shake" style="cursor:pointer"
        >
          <div class="vtd-home-block">
            <h6 class="vtd-card-title d-none d-lg-block">02</h6>
            <h5> MY<br/>POST TRAVEL BRIEFS (COMING SOON)</h5>
            <div class="vtd-text-center">
              <i class="material-icons vtd-icon-7"></i>
            </div>
            <p class="d-none d-lg-block ml-2" style="text-align: left">View/Edit your post travel briefs</p>
          </div>
          <div class="vtd-card-footer vtd-text-center d-none d-lg-block">
            <p class="vtd-home-btn pl-2">View and Edit</p>
          </div>
        </a>
      </b-col>
    </b-row>
    <LoginKb ref="LoginKbRef" />
    <ConsultantBioImage ref="ConsultantImageRef" />
  </HomeLayout>
</template>

<script>
import HomeLayout from "@/partials/home-layout"
import LoginKb from "./login-kb"
import ConsultantBioImage from "./consultant-pic-upload"
import { mapGetters } from "vuex";

export default {
  components: {
    HomeLayout,
    LoginKb,
    ConsultantBioImage
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'staff/isAuthenticated'
    })
  },
  methods: {
    clickBioPicture() {

      if (this.isAuthenticated) {
        this.$refs.ConsultantImageRef.showModal()
      } else {
        this.$refs.LoginKbRef.showModal(() => {
          this.$refs.ConsultantImageRef.showModal()
        })
      }
    }
  }
}
</script>

<style>
  @import './styles.scss';
</style>
